import { dateFormatter } from '../common/formatter';

export const months = ['Jan' ,'Feb','Mar', 'Apr','May','Jun','Jul' ,'Aug' ,'Sept' ,'Oct' ,'Nov' ,'Dec'];

export const dailyPublishedBudgetFormatter = (dailyPublishedBudget) => {

    const {convertDateFromUTCToLocal} = dateFormatter;

    const formatedDailyPublishedBudget = [];
    let sum = 0;

    dailyPublishedBudget.forEach( (dailyPublished) =>{
        const tempDate = convertDateFromUTCToLocal(new Date(dailyPublished.published_date));
        sum += dailyPublished.published_daily_budget;
        const dailyBudget = {
            publishedDailyBudget : sum,
            publishedDate :tempDate
        };
        formatedDailyPublishedBudget.push(dailyBudget);
    });

    return formatedDailyPublishedBudget;
};